import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-corporates-page",
    templateUrl: "./corporates-page.component.html",
    styleUrls: ["./corporates-page.component.scss"],
    standalone: false
})
export class CorporatesPageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
